import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BooksLoginSuggestAlert.module.scss';

interface Props {
  className?: string;
  onClick: () => void;
}

const BooksLoginSuggestAlert = ({
  className,
  intl,
  onClick,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksLoginSuggestAlert, className);

  return (
    <div className={classes}>
      <p className={css.BooksLoginSuggestAlert__Paragraph}>
        <FormattedMessage
          id="books.forms.loginSuggestAlertMessage1"
          values={{
            login: (
              <a
                onClick={onClick}
                className={css.BooksLoginSuggestAlert__Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({ id: 'books.forms.toLogin' })}
              </a>
            ),
          }}
        />
      </p>
      <p className={css.BooksLoginSuggestAlert__Paragraph}>
        {intl.formatMessage({ id: 'books.forms.loginSuggestAlertMessage2' })}
      </p>
    </div>
  );
};

export default injectIntl(BooksLoginSuggestAlert);
